import React from "react";
import Button from "@mui/material/Button";
import { AlertIcon } from "@logora/parliament.icons.regular_icons";
import styles from "./FollowButton.module.scss";
import cx from "classnames";

interface FollowButtonProps {
  onFollow: () => void;
  active: boolean;
  size?: "small" | "medium" | "large";
  variant?: "colored" | "light"
  onClick?: () => void;
}

export const FollowButton: React.FC<FollowButtonProps> = ({
  onFollow,
  onClick,
  active,
  size = "medium",
  variant = "light"
}) => {
  const follow = () => {
    onFollow();
  };

  return (
    <Button
      onClick={onClick || follow}
      variant={"outlined"}
      className={cx(
        styles.buttonContainer,
        { [styles.colored]: variant === "colored" },
        { [styles.light]: variant === "light" },
        { [styles.active]: active },
        { [styles.small]: size === "small" },
        { [styles.medium]: size === "medium" },
        { [styles.large]: size === "large" }
      )}
    >
      <AlertIcon />
      {active ? "Suivi" : "Suivre"}
    </Button>
  );
};
